module.exports = __webpack_public_path__ + "static/img/12.fffc6a3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/7/1/eng/12.png
// module id = AJfB
// module chunks = 0